import React, { forwardRef } from 'react';
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
};
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  padding = 'md',
  className = '',
  children,
  ...props
}, ref) => {
  return <div ref={ref} className={`bg-white rounded-xl border border-slate-200/60 shadow-[0_1px_3px_rgba(0,0,0,0.04)] ${paddingStyles[padding]} ${className}`} {...props} data-id="element-195">
        {children}
      </div>;
});
Card.displayName = 'Card';
interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}
export function CardHeader({
  title,
  subtitle,
  action,
  className = '',
  ...props
}: CardHeaderProps) {
  return <div className={`flex items-start justify-between ${className}`} {...props} data-id="element-196">
      <div data-id="element-197">
        <h3 className="text-base font-bold text-slate-900 font-heading" data-id="element-198">
          {title}
        </h3>
        {subtitle && <p className="mt-1 text-sm text-slate-500 font-medium" data-id="element-199">{subtitle}</p>}
      </div>
      {action && <div data-id="element-200">{action}</div>}
    </div>;
}